<h1 mat-dialog-title>{{ 'dataManagement.userData.texts.' + (isEditing ? 'edit' : 'add') | transloco }}</h1>

<mat-dialog-content [class.dialog-content]="action !== dialogActions.DELETE">
  <form [formGroup]="addEditUserForm">

    <div *ngIf="action !== dialogActions.DELETE; else deleteTemplate">
      <div class="grid-container">
        <mat-card>

          <mat-card-content>
            <div class="left">
              <mat-form-field class="input-field">
                <mat-label class="label-large">
                  {{ 'dataManagement.userData.columns.name' | transloco }}
                </mat-label>
                <input matInput formControlName="name" autocomplete="off" type="text"
                  [ngClass]="{ 'is-invalid': submitted && formControls.name.errors }">
              </mat-form-field>
              <div class="error" *ngIf="formControls.name.errors">
                <mat-error *ngIf="formControls.name.hasError('required') && submitted">
                  {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
                </mat-error>
                <mat-error *ngIf="formControls.name.hasError('pattern')">
                  {{ 'dataManagement.userData.userDialog.validation.pattern' | transloco }}
                </mat-error>
                <mat-error *ngIf="formControls.name.hasError('maxlength')">
                  {{ 'dataManagement.userData.userDialog.validation.maxLength' | transloco: {maxLength: maxLength} }}
                </mat-error>
                <mat-error *ngIf="formControls.name.hasError('minlength')">
                  {{ 'dataManagement.userData.userDialog.validation.minLength' | transloco: {minLength: minLength} }}
                </mat-error>
                <mat-error *ngIf="formControls.name.hasError('userNameIsAlreadyUsed')">
                  {{ 'dataManagement.userData.userDialog.validation.userNameIsAlreadyUsed' | transloco }}
                </mat-error>
              </div>

              <mat-form-field class="input-field">
                <mat-label class="label-large">
                  {{ 'dataManagement.userData.columns.email' | transloco }}
                </mat-label>
                <input matInput formControlName="email" autocomplete="off" type="text"
                  [ngClass]="{ 'is-invalid': submitted && formControls.email.errors }">
              </mat-form-field>
              <div class="error" *ngIf="formControls.email.errors">
                <mat-error *ngIf="formControls.email.hasError('required') && submitted">
                  {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
                </mat-error>
                <mat-error *ngIf="formControls.email.hasError('email')">
                  {{ 'dataManagement.userData.userDialog.validation.email' | transloco }}
                </mat-error>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-content>
            <div class="left">
              <app-password-form formControlName="newPassword" [submitted]="submitted" [isAdmin]="isAdmin">
              </app-password-form>
            </div>
          </mat-card-content>
        </mat-card>

      </div>
    </div>
    <ng-template #deleteTemplate>
      {{ 'dataManagement.userData.texts.deleteConcreteItemConfirmation' | transloco }}
    </ng-template>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button *ngIf="action===dialogActions.ADD" (click)="doAction()" mat-raised-button type="submit"
    color="primary">{{ 'common.buttons.add' | transloco }}</button>
  <button *ngIf="action===dialogActions.EDIT" (click)="doAction()" mat-raised-button type="submit"
    color="primary">{{ 'common.buttons.edit' | transloco }}</button>
  <button *ngIf="action===dialogActions.DELETE" (click)="doAction()" mat-raised-button type="submit"
    color="primary">{{ 'common.buttons.delete' | transloco }}</button>
  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.cancel' | transloco }}</button>
</mat-dialog-actions>
